// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1YDG2","captchaBackground":"style_captchaBackground__1JhmP","captchaImage":"style_captchaImage__3WKMW"};